import { MEDIA_BASE_URL } from '@/environments/environment';

export function mediaUrl(path?: string | null): string {
  if (!path) return '';
  if (/^https?:\/\//i.test(path)) return path;

  return `${MEDIA_BASE_URL.replace(/\/$/, '')}/${path.replace(/^\//, '')}`;
}
